import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModalRef, NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { MenuService } from '../../services/menu.service';
import { AuthService } from '../../services/auth/auth.service';
import { NotificationService } from '../../services/notification.service';
import { TRANSLATIONS_EN } from 'src/app/i18n/translations.en';
import { TRANSLATIONS_HI } from 'src/app/i18n/translations.hi';
import { ToastService } from 'src/app/toast/toast.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { NavigationComponent } from 'src/app/shared/header/navigation.component';
import { FormsModule } from '@angular/forms';

interface NavItem {
  icon: string;
  label: string;
  route: string;
  active?: boolean;
  children?: NavItem[];
  expanded?: boolean;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NavigationComponent, NgbDropdownModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  @ViewChild('notifDropdown') notifDropdown!: NgbDropdown;

  // User & authentication
  isAuthenticated = false;
  userName = 'Guest';
  roleName = '';
  societyId: number | null = null;
  roleId: number | null = null;
  imageUrl: string | null = null;
  token: any;
  selectedRole: any
  // Menu
  showMenu = '';
  navItems: NavItem[] = [];
  menuItems: any[] = [];
  openIndex: number | null = null;

  // Notifications
  notifications: any[] = [];
  visibleNotifications: any[] = [];
  notificationCount = 0;
  showAllNotifications = false;
  modalRef: NgbModalRef | null = null;
  errorMessage = '';

  // Time
  currentDate = new Date();

  // Language
  isEnglish = true;
  selectedRoleId: number | null = null;

  translations = TRANSLATIONS_EN;
  roles: any[] = [];
  constructor(
    private modalService: NgbModal,
    private router: Router,
    private menuService: MenuService,
    private authService: AuthService,
    private toastService: ToastService,
    private notificationService: NotificationService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    // Subscribe to current user
    this.authService.currentUserSubject.subscribe(user => {
      this.isAuthenticated = !!user;
      this.userName = `${user?.firstName || 'Guest'} ${user?.lastName || ''}`;
      this.roleName = user?.roleName || '';
      this.societyId = user?.societyId != null ? Number(user.societyId) : null;
      this.roleId = user?.roleId || null;
      this.selectedRoleId = user?.roleId || null;
      this.imageUrl = user?.imageurl ? this.configService.getprofileUrl() + user.imageurl : null;
      this.token = localStorage.getItem('authToken');
      this.roles = user?.roles || [];
      if (this.isAuthenticated) {
        this.getMenu();
        if (this.roleId) this.getNotifications(1, this.roleId);
      }
    });

    // Update time every second
    setInterval(() => (this.currentDate = new Date()), 1000);
  }

  // Display only: Society User + Act year for role 9.
  get displayRoleName(): string {
    if (Number(this.roleId) === 9) {
      if (Number(this.societyId) === 1) {
        return 'Society User 2006';
      }
      if (Number(this.societyId) === 2) {
        return 'Society User 1968';
      }
    }
    return this.roleName || '';
  }

  getCurrentRoleId() {
    const user: any = localStorage.getItem('currentUser');

    return user?.roleId;
  }
  /* --------------------------- MENU METHODS --------------------------- */
  addExpandClass(element: string): void {
    this.showMenu = element === this.showMenu ? '0' : element;
  }

  setOpen(index: number): void {
    this.openIndex = index;
  }

  closeMenu(): void {
    this.openIndex = null;
  }

  isOpen(index: number): boolean {
    return this.openIndex === index;
  }

  getVisibleMenu(item: any): any[] {
    return item.children?.filter((x: any) => x.isVisible === true) || [];
  }
  roleList: any[] = []


  selectRole(event: any) {
    const roleId = Number(event.target.value);
    if (!roleId) return;

    const phisnumber = this.authService?.currentUserValue?.phisNumber;

    const password = this.authService?.currentUserValue?.password;

    const payload = {
      UserId: phisnumber,
      Password: password,
      rememberMe: '',
      RoleId: roleId

    };



    this.authService.login(payload).subscribe(res => {

      if (res.status === 200) {
        this.authService.storeUser(res.data);

        localStorage.removeItem("loginPayload");

        this.navigateByRole(res.data.roleId);
      }
      else {
        this.toastService.showError(res.message);
      }

    }, err => {
      this.toastService.showError('Role login failed');
    });
  }
  private navigateByRole(roleId: number) {
    if (roleId === 1) {
      this.router.navigate(['/admin/AdminDash']);
    } else {
    
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard']);
          });
    }
  }


  getMenu(): void {
    this.menuService.getMenuForHeader().subscribe({
      next: response => {
        this.menuItems = response.data;
        this.navItems = this.transformMenu(response.data);
      },
      error: error => console.error('Error fetching menu:', error)
    });
  }

  transformMenu(menuData: any[]): NavItem[] {
    return menuData
      .filter(item => item.isVisible !== false)
      .map(item => ({
        icon: item.className?.replace('bi ', '') || '',
        label: item.menuName,
        route: item.menuLink !== '#' ? item.menuLink : '',
        active: false,
        children: item.children?.length ? this.transformMenu(item.children) : []
      }));
  }

  /* ---------------------- NOTIFICATION METHODS ----------------------- */
  getNotifications(flag: number, roleId: number): void {
    this.notificationService.getNotifications(flag, roleId).subscribe({
      next: response => {
        if (response.status === 200) {
          this.notifications = response.data;
          this.visibleNotifications = this.notifications.slice(0, 3);
          this.notificationCount = this.notifications.length;
        }
      },
      error: error => {
        this.toastService.showError(error);
        this.errorMessage = 'Error fetching notifications: ' + error.message;
      }
    });
  }

  toggleNotificationDropdown(): void {
    this.visibleNotifications = this.showAllNotifications ? this.notifications : this.notifications.slice(0, 3);
  }

  readNotification(event: MouseEvent, id: any): void {
    event.preventDefault();
    event.stopPropagation();

    this.notificationService.updateNotification(id, this.roleId).subscribe({
      next: response => {
        if (response.status === 200) {
          this.notifications = this.notifications.filter(n => n.Id !== id);
          this.visibleNotifications = this.showAllNotifications ? this.notifications : this.notifications.slice(0, 3);

          setTimeout(() => {
            if (!this.notifDropdown.isOpen()) this.notifDropdown.open();
          }, 0);
        }
      },
      error: error => {
        this.toastService.showError(error);
        this.errorMessage = 'Error updating notification: ' + error.message;
      }
    });
  }

  viewMoreNotifications(content: any): void {
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  /* --------------------------- AUTH METHODS --------------------------- */
  logOut(): void {
    this.authService.logout();
    // this.isAuthenticated = false;
  }

  checkAndLogoutIfExpired(): void {
    if (this.authService.isTokenExpired(this.token)) {
      this.logOut();
    }
  }

  /* --------------------------- MISC METHODS --------------------------- */
  get avatarUrl(): string {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(this.userName)}&background=0f4c81&color=fff&size=40`;
  }

  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish;
    this.translations = this.isEnglish ? TRANSLATIONS_EN : TRANSLATIONS_HI;
  }
}
